import React from 'react';
import { useListConversations } from '../../api/conversations';
import { ConversationView } from '../ConversationView';
import { EmptyState } from '../../components/common/EmptyState';
import { LoadingState } from '../../components/common/LoadingState';
import { ConversationStatusBadge } from '../../components/common/ConversationStatusBadge';

import { useTranslation } from 'react-i18next';

interface TaskLastExecutionProps {
  taskId: string;
}

export const TaskLastExecution: React.FC<TaskLastExecutionProps> = ({
  taskId,
}) => {
  const { t } = useTranslation('pleri/pages');
  const { data, isLoading } = useListConversations({
    source: 'task',
    sourceId: taskId,
    limit: 1,
  });

  if (isLoading) {
    return <LoadingState text={t('loadingLastExecution')} />;
  }

  const lastExecution = data?.conversations?.[0];

  if (!lastExecution) {
    return (
      <EmptyState
        title={t('noExecutionsYet')}
        description={t('runThisTaskToSeeExecutionDetails')}
      />
    );
  }

  // Check if execution is still running
  const isRunning =
    lastExecution.status === 'running' || lastExecution.status === 'thinking';

  return (
    <div className="space-y-4">
      <div>
        <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100">
          {t('lastExecutionDetails')}
        </h3>
        <p className="mt-1 text-sm text-gray-600 dark:text-gray-400">
          {t('statusLabel')}
          <ConversationStatusBadge status={lastExecution.status} />
        </p>
      </div>
      <div className="rounded-lg border border-gray-200 bg-white dark:border-gray-700 dark:bg-gray-900">
        <ConversationView
          showMessageFromIndex={1}
          conversationId={lastExecution.conversationId}
          headerText=""
          autoRefresh={isRunning}
          autoScrollToBottom={isRunning}
        />
      </div>
    </div>
  );
};
